var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#00599b"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }